import { SET_DATA } from 'helpers/Constants';
import { TERTIARY_TEXT } from 'styles/Colors';
import { useDispatch, useSelector } from 'react-redux';
// import Checkbox from '@mui/material/Checkbox';
import Checkbox from 'components/forms/Checkbox';
import React from 'react';

const containerStyle = {
  alignItems: 'start',
  color: TERTIARY_TEXT,
  display: 'flex'
};

const footerStyle = {
  fontSize: '87.5%',
  fontStyle: 'italic',
  marginTop: '0.5rem'
};

function label() {
  return (
    <>
      <div>
        I consent to receive SMS text messages at the mobile number I have
        provided for account and billing related notifications and alerts from
        OppLoans. I acknowledge and consent to receive calls from OppLoans from
        an automatic telephone dialing system to the number provided. I
        understand that I can opt-out of receiving these messages at any time by
        replying STOP, and I can request assistance by replying HELP. For
        Support, call (800) 990-9130. Message and data rates may apply. Message
        frequency varies.
      </div>
      <div style={footerStyle}>
        This authorization is not a condition for purchasing any goods or
        services.
      </div>
    </>
  );
}

function MarketingDisclosure({ style = {} }) {
  const marketingDisclosure = useSelector((state) => state.marketingDisclosure);
  const dispatch = useDispatch();

  return (
    <div css={[containerStyle, style]}>
      <Checkbox
        id='marketingDisclosure'
        name='marketingDisclosure'
        value={marketingDisclosure || false}
        checked={marketingDisclosure || false}
        onChange={(e) => {
          dispatch({
            type: SET_DATA,
            payload: { marketingDisclosure: e.target.checked }
          });
        }}
        additionalCheckboxStyle={{ borderRadius: 0 }}
        additionalLabelStyle={{
          fontSize: '10px',
          display: 'flex',
          placeItems: 'center stretch',
          padding: '0.5rem'
        }}
      />
      <span>{label()}</span>
    </div>
  );
  //     id='registration_disclaimers_marketing_disclosure'
}

export default MarketingDisclosure;
